export const smartDocStaticParamType_Orders_SubType_Test = 'test';
export const smartDocStaticParamType_Orders_SubType_Consult = 'consult';
export const smartDocStaticParamType_Orders_SubType_Treatment = 'treatment';
export const smartDocStaticParamType_Orders_SubType_POC = 'poc';
export const smartDocStaticParamType_Orders_SubType_ActivateProtocol = 'activate-protocol';
export const smartDocStaticParamType_Orders_SubTypes = [
    smartDocStaticParamType_Orders_SubType_Test,
    smartDocStaticParamType_Orders_SubType_Consult,
    smartDocStaticParamType_Orders_SubType_Treatment,
    smartDocStaticParamType_Orders_SubType_POC,
    smartDocStaticParamType_Orders_SubType_ActivateProtocol,
];
export const smartDocStaticParamType_Orders_Status_Pending = 'PENDING';
export const smartDocStaticParamType_Orders_Status_Resulted = 'RESULTED';
export const smartDocStaticParamType_Orders_Status_Recommended = 'RECOMMENDED';
export const smartDocStaticParamType_Orders_Status_FoundInFHIR = 'FOUND_IN_FHIR';
export const smartDocStaticParamType_Orders_Status_Completed = 'COMPLETED';
export const smartDocStaticParamType_Orders_Statuses = [
    smartDocStaticParamType_Orders_Status_Pending,
    smartDocStaticParamType_Orders_Status_Resulted,
    smartDocStaticParamType_Orders_Status_Recommended,
    smartDocStaticParamType_Orders_Status_FoundInFHIR,
    smartDocStaticParamType_Orders_Status_Completed,
];
export const smartDocStaticParamType_Orders = 'orders';
//# sourceMappingURL=types.js.map